module.exports = __webpack_public_path__ + "img/1c959e5.png";